import React from 'react';

export default function NotesSection({ formData, onChange }) {
  return (
    <div>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: 'var(--text-primary)',
        marginBottom: '16px'
      }}>
        Notes
      </h3>

      {/* Customer Notes */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Customer Notes
        </label>
        <textarea
          value={formData.notes || ''}
          onChange={(e) => onChange({ notes: e.target.value })}
          placeholder="Special requests, access instructions, etc."
          rows={4}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none',
            fontFamily: 'inherit',
            resize: 'vertical'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
        />
        <div style={{
          fontSize: '11px',
          color: 'var(--text-tertiary)',
          marginTop: '4px'
        }}>
          Visible to customer and staff
        </div>
      </div>

      {/* Internal Notes */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '6px'
        }}>
          Internal Notes
        </label>
        <textarea
          value={formData.internalNotes || ''}
          onChange={(e) => onChange({ internalNotes: e.target.value })}
          placeholder="Staff-only notes, payment info, issues, etc."
          rows={4}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none',
            fontFamily: 'inherit',
            resize: 'vertical'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--brand-brown)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--input-border)'}
        />
        <div style={{
          fontSize: '11px',
          color: 'var(--text-tertiary)',
          marginTop: '4px'
        }}>
          Staff only - not visible to customer
        </div>
      </div>
    </div>
  );
}